var B = Object.defineProperty, L = Object.defineProperties;
var M = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var A = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var v = (o, n, r) => n in o ? B(o, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[n] = r, t = (o, n) => {
  for (var r in n || (n = {}))
    A.call(n, r) && v(o, r, n[r]);
  if (a)
    for (var r of a(n))
      y.call(n, r) && v(o, r, n[r]);
  return o;
}, O = (o, n) => L(o, M(n));
var T = (o, n) => {
  var r = {};
  for (var i in o)
    A.call(o, i) && n.indexOf(i) < 0 && (r[i] = o[i]);
  if (o != null && a)
    for (var i of a(o))
      n.indexOf(i) < 0 && y.call(o, i) && (r[i] = o[i]);
  return r;
};
import { jsxs as c, jsx as d } from "react/jsx-runtime";
import { AnimatePresence as V } from "framer-motion";
import e from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as Z, useState as $ } from "react";
import * as D from "./style.es.js";
import { Accordion as F, AccordionHeader as G, AccordionHeaderStart as J, AccordionHeaderContent as K, AccordionHeaderEnd as Q, AccordionBody as U } from "./style.es.js";
import { renderElement as p } from "../../../helpers/renderElement.es.js";
import { Icon as b, iconPropTypes as W } from "../Icon/Icon.es.js";
import { COLOR_VARIANT as P } from "../../../constants/colorVariant.es.js";
import { COMPONENT_SIZE as R } from "../../../constants/sizes.es.js";
const l = Z((Y, k) => {
  var g = Y, {
    children: o,
    description: n,
    descriptionProps: r,
    disabled: i = !1,
    endContent: x,
    endContentProps: C,
    headerRef: j,
    icon: m,
    iconName: f,
    iconProps: w,
    onToggle: h,
    title: u,
    titleProps: E,
    variant: H = P.text,
    size: I = R.md,
    isActive: N = !1
  } = g, S = T(g, [
    "children",
    "description",
    "descriptionProps",
    "disabled",
    "endContent",
    "endContentProps",
    "headerRef",
    "icon",
    "iconName",
    "iconProps",
    "onToggle",
    "title",
    "titleProps",
    "variant",
    "size",
    "isActive"
  ]);
  const [s, q] = $(N), _ = () => {
    q((z) => !z), h && h();
  };
  return /* @__PURE__ */ c(F, O(t({ ref: k, variant: H, isOpen: s, size: I }, S), { children: [
    /* @__PURE__ */ c(G, { onClick: _, disabled: !!i, ref: j, children: [
      /* @__PURE__ */ c(J, { children: [
        m || f && /* @__PURE__ */ d(b, t({ name: f, color: "var(--color-success-default)" }, w)),
        (u || n) && /* @__PURE__ */ c(K, { children: [
          p(t({
            content: u,
            variant: "body1",
            underline: !0
          }, E)),
          p(t({
            content: n,
            variant: "caption1",
            underline: !0,
            color: "fg",
            emphasis: "weak"
          }, r))
        ] })
      ] }),
      /* @__PURE__ */ c(Q, { children: [
        p(t({
          content: x,
          variant: "body1"
        }, C)),
        /* @__PURE__ */ d(b, { name: s && !i ? "down-chevron" : "right-chevron" })
      ] })
    ] }),
    /* @__PURE__ */ d(V, { children: s && !i && /* @__PURE__ */ d(U, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
      open: {
        opacity: 1,
        height: "auto",
        overflow: "hidden",
        marginTop: 16
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    }, transition: {
      duration: 0.2,
      ease: "linear"
    }, children: o }) })
  ] }));
}), X = {
  children: e.node.isRequired,
  description: e.oneOfType([e.node, e.string]),
  disabled: e.bool,
  endContent: e.oneOfType([e.node, e.string]),
  headerRef: e.func,
  icon: e.node,
  iconName: e.string,
  iconProps: e.oneOf([e.shape(W), void 0]),
  onToggle: e.func,
  isActive: e.bool,
  size: e.oneOf(Object.values(R)),
  title: e.oneOfType([e.node, e.string]).isRequired,
  variant: e.oneOf(Object.values(P))
};
l.S = D;
l.displayName = "Accordion";
l.propTypes = X;
export {
  l as Accordion,
  X as accordionPropTypes
};
//# sourceMappingURL=Accordion.es.js.map
